import { render, staticRenderFns } from "./EnquiryAttachmentDialog.vue?vue&type=template&id=3b72272a&"
import script from "./EnquiryAttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./EnquiryAttachmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QFile,QIcon,QCheckbox,QSelect,QToggle,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QFile,QIcon,QCheckbox,QSelect,QToggle,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
